"use strict";

angular
    .module(ApplicationConfiguration.applicationModuleName)
    .controller(
        "dashboardColorsCtrl",
        function (
            $scope,
            $sessionStorage,
            ColorRequest,
            status,
            settings,
            states, managers,
            $localStorage,
            $state
        ) {
            var vm = this;
            vm.settings = settings;

            vm.isDesigner = function () { return vm.settings.isColorsUserGroupByName('Designer'); };
            vm.isVendedor = function () { return vm.settings.isColorsUserGroupByName('VendedorBalcao'); };
            vm.isControleQualidade = function () { return vm.settings.isColorsUserGroupByName('ControleQualidade'); };
            vm.isGerenteNacional = function () { return vm.settings.isColorsUserGroupByName('GerenteNacional'); };
            vm.isGerenteRegional = function () { return vm.settings.isColorsUserGroupByName('GerenteRegional'); };

            angular.extend($scope.$parent.vm, {
                title: 'Dashboard',
                insertUrl: null,
            });

            if (!$localStorage || !$localStorage.groups || !$localStorage.groups.length) {
                settings.signOut();
                $state.go("login");
            }

            vm.status = status;
            vm.model = null;
            vm.states = states;
            vm.managers = managers;
            vm.groups = window.enumerators.enumGroupsColorsRequests;


            //collapses
            vm.filterCollapse = true;
            vm.dashCollapse = true;


            vm.chartOptions = {
                responsive: true,
                events: true,
                tooltips: {
                    enabled: false
                },
                layout: {
                    padding: {
                        top: 20, // Adiciona 20 pixels de padding no topo
                    }
                },
                animation: {
                    duration: 500,
                    onComplete: function () {
                        var chartInstance = this.chart,
                            ctx = chartInstance.ctx;
                        ctx.font = Chart.helpers.fontString(10, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
                        ctx.textAlign = 'end';
                        ctx.textBaseline = 'alphabetic';
                        ctx.fillStyle = 'black'; // Define a cor do texto aqui

                        var canvasElement = chartInstance.canvas;
                        var currencyFormat = canvasElement.getAttribute('data-currency-format') === "true"; // Lê o atributo personalizado

                        this.data.datasets.forEach(function (dataset, i) {
                            var meta = chartInstance.controller.getDatasetMeta(i);
                            meta.data.forEach(function (bar, index) {

                                var data = dataset.data[index];

                                if (currencyFormat) {
                                    // Format the value as currency here
                                    var formattedValue = Number(data).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                                    ctx.fillText(formattedValue, bar._model.x, bar._model.y - 5);
                                } else {
                                    ctx.fillText(data, bar._model.x, bar._model.y - 5);
                                }
                            });
                        });
                    }
                }
            };

            vm.getThisYearMonthsLabels = function () {
                // Array com todos os meses do ano em português
                const todosMeses = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];

                // Obter o mês atual (Janeiro é 0, Fevereiro é 1, etc.)
                const mesAtual = new Date().getMonth();

                // Gerar a lista de meses desde janeiro até o mês atual
                const mesesAteAgora = todosMeses.slice(0, mesAtual + 1);

                return mesesAteAgora;
            }
            vm.months = vm.getThisYearMonthsLabels();

            vm.showStatusList = function () {
                return vm.isDesigner() || vm.isVendedor() || vm.isControleQualidade()
            }

            vm.showRankings = function () {
                return vm.isGerenteRegional() || vm.isGerenteNacional() || vm.isControleQualidade();
            }

            vm.showManagmentDash = function () {
                return vm.isControleQualidade();
            }

            vm.showTotalCards = function () {
                return vm.isGerenteRegional() || vm.isGerenteNacional() || vm.isControleQualidade();
            }


            vm.fillDash = function (data) {
                if (!data) return;
                vm.dash = data;
                if (!vm.months) {
                    vm.months = vm.getThisYearMonthsLabels();
                }

                for (var index = 0; index < vm.dash.colorsList.length; index++) {
                    const e = vm.dash.colorsList[index];
                    e.position = `${index + 1}º`;
                }

                for (var index = 0; index < vm.dash.productsList.length; index++) {
                    const e = vm.dash.productsList[index];
                    e.position = `${index + 1}º`;
                }

                vm.data = vm.dash.statusList.map((x) => x.count);
                vm.labels = vm.dash.statusList.map((x) => x.name);
                vm.colorsChart = vm.dash.statusList.map((x) => x.color);

                vm.dash.countProjects = vm.dash.statusList.reduce((sum, x) => sum + (x.count || 0), 0);

                vm.barLineChartProjectsFill();
                vm.barLineChartSalesFill();
                vm.barLineChartFillProjectsGerentes();
                vm.barLineChartFillSalesGerentes();
                vm.barLineChartOtherProductsFill();
                vm.barLineChartTintingProductsFill();
            };

            vm.fillChartData = function (dataSource, chartType, colorBar, colorLine, currencyFormat) {
                if (!dataSource || !dataSource.series || !dataSource.series.length) {
                    return {};
                }
                const _customChartOption = Object.assign({}, vm.chartOptions);

                const years = dataSource.series.map(year => parseInt(year));
                const maxYear = Math.max(...years);

                const generateLineColor = (index) => {
                    const baseColor = colorLine.split(', ').map(Number);
                    const increment = index * 40;
                    return [
                        (baseColor[0] + increment) % 256, // Red
                        (baseColor[1] + increment) % 256, // Green
                        (baseColor[2] + increment) % 256  // Blue
                    ].join(', ');
                };

                const formattedSeries = dataSource.series.map((yearStr, _index) => {
                    const year = parseInt(yearStr);

                    if (year === maxYear) {
                        // Ano atual: cor da barra
                        return {
                            name: yearStr,
                            color: `rgba(${colorBar}, 0.4)`,
                            border: `rgba(${colorBar}, 1)`
                        };
                    } else {
                        // Anos anteriores: cores únicas baseadas em colorLine
                        const lineColor = generateLineColor(_index);
                        return {
                            name: yearStr,
                            color: `rgba(${lineColor}, 1)`,
                            border: `rgba(${lineColor}, 1)`
                        };
                    }
                });

                const datasetOverride = dataSource.series.map((yearStr) => {
                    const year = parseInt(yearStr);
                    if (year === maxYear) {
                        return {
                            type: 'bar',
                            backgroundColor: `rgba(${colorBar}, 0.4)`,
                            borderColor: `rgba(${colorBar}, 1)`,
                            borderWidth: 1
                        };
                    } else {
                        // Dataset da linha (ano anterior)
                        const seriesEntry = formattedSeries.find(s => s.name === yearStr);
                        const lineColor = seriesEntry.border.replace('rgba(', '').replace(')', '').split(', ').slice(0, 3).join(', ');
                        return {
                            type: 'line',
                            fill: false,
                            clip: true,
                            borderColor: `rgba(${lineColor}, 1)`,
                            backgroundColor: `rgba(${lineColor}, 0.2)`,
                            pointBorderColor: `rgba(${lineColor}, 1)`,
                            pointBackgroundColor: '#fff',
                            pointHoverBackgroundColor: `rgba(${lineColor}, 1)`,
                            pointHoverBorderColor: `rgba(${lineColor}, 1)`,
                            yAxisID: 'y-axis-2'
                        };
                    }
                });

                _customChartOption.scales = {
                    yAxes: [
                        {
                            id: 'y-axis-2',
                            type: 'linear',
                            position: 'right',
                            gridLines: {
                                drawOnArea: false
                            },
                            ticks: {
                                autoSkip: true,
                                fontSize: 10,
                                padding: 20,
                                maxTicksLimit: 10,
                                beginAtZero: true,
                                callback: function (value) {
                                    if (currencyFormat) {
                                        return 'R$ ' + Number(value).toLocaleString('pt-BR');
                                    } else {
                                        return value;
                                    }
                                }
                            }
                        },
                        {
                            id: 'y-axis-1',
                            type: 'linear',
                            position: 'left',
                            ticks: {
                                autoSkip: true,
                                fontSize: 10,
                                padding: 50,
                                maxTicksLimit: 10,
                                beginAtZero: true,
                                callback: function (value) {
                                    return "";
                                }
                            }
                        }
                    ],
                };


                // HOVER NÃO FUNCIONA
                // _customChartOption.tooltips = {
                //     enabled: true,
                //     mode: 'index',
                //     intersect: false,
                //     backgroundColor: 'rgba(0, 0, 0, 0.7)',
                //     titleFontSize: 12,
                //     bodyFontSize: 12,
                //     callbacks: {
                //         title: function (tooltipItems, data) {
                //             return data.labels[tooltipItems[0].index];
                //         },
                //         label: function (tooltipItem, data) {
                //             const dataset = data.datasets[tooltipItem.datasetIndex];
                //             const label = dataset.label || data.series[tooltipItem.datasetIndex];
                //             let value = dataset.data[tooltipItem.index];

                //             if (currencyFormat) {
                //                 value = 'R$ ' + Number(value).toLocaleString('pt-BR');
                //             }

                //             return `${label}: ${value}`;
                //         }
                //     }
                // };

                // _customChartOption.hover = {
                //     mode: 'index',
                //     intersect: false
                // };

                return {
                    labels: dataSource.labels,
                    series: dataSource.series,
                    data: dataSource.data,
                    legend: formattedSeries,
                    datasetOverride: datasetOverride,
                    options: _customChartOption
                };
            };

            vm.barLineChartProjectsFill = function () {
                vm.chartProjectsData = vm.fillChartData(
                    vm.dash.projectsEvolutionWithLastYearChart,
                    'barLine',
                    '183, 18, 52',  // Cor do Bar
                    '0, 103, 178',   // Cor da Line
                    false
                );
            };

            vm.barLineChartSalesFill = function () {
                vm.chartSalesData = vm.fillChartData(
                    vm.dash.salesTotalEvolutionWithLastYearChart,
                    'barLine',
                    '0, 103, 178',  // Cor do Bar
                    '183, 18, 52',   // Cor da Line
                    true
                );
            };

            vm.barLineChartOtherProductsFill = function () {
                vm.chartOtherProductsData = vm.fillChartData(
                    vm.dash.salesOthersProductsEvolutionWithLastYearChart,
                    'barLine',
                    '239, 108, 0',  // Cor do Bar
                    '38, 166, 154',   // Cor da Line
                    true
                );
            };

            vm.barLineChartTintingProductsFill = function () {
                vm.chartTintingProductsData = vm.fillChartData(
                    vm.dash.salesTintingProductsEvolutionWithLastYearChart,
                    'barLine',
                    '38, 166, 154',  // Cor do Bar
                    '239, 108, 0',   // Cor da Line
                    true
                );
            };

            vm.findNearestIndexInChartGerentes = function (selectedMonth, labels) {
                if (!selectedMonth || !labels) {
                    return 1;
                }

                // Tenta encontrar o índice do mês selecionado em vm.labels
                var labelIndex = labels.indexOf(selectedMonth);

                // Se o índice não for encontrado, retorna o último índice de vm.labels
                if (labelIndex === -1) {
                    labelIndex = labels.length - 1;
                }

                return labelIndex;
            }

            vm.fillManagerChart = function (dashSource) {
                let chartData = {};
                const dateNow = new Date();
                let currentDate = dateNow.getFullYear() + ' - ' +
                    dateNow.toLocaleString('pt-BR', { month: 'short' })
                        .toLowerCase()
                        .replace('.', '');

                const selectedMonth = vm.months.find(function (month) { return month === currentDate }) ? currentDate : dashSource.labels[0];

                chartData.labels = dashSource.series;
                chartData.originalData = dashSource.data;
                chartData.originalLabels = dashSource.labels;
                chartData.selectedMonth = selectedMonth; // Mês atual
                chartData.options = vm.chartOptions;

                return chartData;
            };

            vm.barLineChartFillProjectsGerentes = function () {
                if (vm.dash.projectsEvolutionByManagerChart) {
                    vm.chartProjectsGerentesData = {};
                    vm.chartProjectsGerentesData = vm.fillManagerChart(vm.dash.projectsEvolutionByManagerChart);
                    vm.updateProjectsManagerChart();
                }
            };

            vm.barLineChartFillSalesGerentes = function () {
                if (vm.dash.salesEvolutionByManagerChart) {
                    vm.chartSalesGerentesData = {};
                    vm.chartSalesGerentesData = vm.fillManagerChart(vm.dash.salesEvolutionByManagerChart);
                    vm.chartSalesGerentesData.options = {
                        ...vm.chartSalesGerentesData.options, scales: {
                            yAxes: [{
                                ticks: {
                                    callback: function (value, index, values) {
                                        return 'R$ ' + value.toLocaleString('pt-BR');
                                    }
                                }
                            }]
                        }
                    }
                    vm.updateSalesManagerChart();
                }
            };

            vm.updateManagerChart = function (chartData) {
                if (chartData && chartData.originalData) {
                    const _index = vm.findNearestIndexInChartGerentes(chartData?.selectedMonth, chartData?.originalLabels);
                    chartData.data = chartData.originalData.map(s => s[_index]);
                }
            };

            vm.updateProjectsManagerChart = function () {
                vm.updateManagerChart(vm.chartProjectsGerentesData);
            };

            vm.updateSalesManagerChart = function () {
                vm.updateManagerChart(vm.chartSalesGerentesData);
            };

            vm.refresh = function (filter) {
                var _filter = filter || $sessionStorage.colorsRequestsContextFilter;
                var filterCustomer = $sessionStorage.colorsRequestsContextFilter_Customer || null;


                if (!_filter) {
                    var todayDate = new Date(Date.now());
                    var firstDayOfTodayYear = new Date(todayDate.getFullYear(), 0, 1);
                    _filter = {
                        startsOn: firstDayOfTodayYear,
                        endsOn: todayDate,
                        expired: false,
                    };
                    $sessionStorage.colorsRequestsContextFilter = _filter;
                }

                _filter.customerId = null;
                if (!filter.startsOn)
                    if (filterCustomer) _filter.customerId = filterCustomer.key;

                ColorRequest.dash(filter).$promise.then(function (data) {
                    vm.model = data;
                    vm.fillDash(vm.model);
                });
            };

            vm.updateFilters = function (filter) {
                vm.refresh(filter);
            };

        }
    );
